import GeneralError from "../../searchFlowVersionB/steps/common/GeneralError.jsx";
import VafActivityDescription from "../steps/VafActivityDescription.jsx";
import VafContactPage from "../steps/VafContactPage.jsx";
import VafIndustryActivity, {
  vafIndustryHasActivityContent,
} from "../steps/VafIndustryActivity.jsx";
import VafIndustrySelect from "../steps/VafIndustrySelect.jsx";
import VafSuccessScreen from "../steps/VafSuccessScreen.jsx";

/** Contact/success/error screens aren't part of the questionnaire — no progress fill there. */
const NON_PROGRESS_STEPS = new Set([VafContactPage, VafSuccessScreen, GeneralError]);

// VafContactPage is appended as a hidden cap (NON_PROGRESS_STEPS hides the bar once
// actually there) so the last *visible* form step never reaches 100% fill.
const buildVafProgressPath = (industry) => {
  const path = [VafIndustrySelect];
  if (vafIndustryHasActivityContent(industry)) {
    path.push(VafIndustryActivity);
  }
  path.push(VafActivityDescription, VafContactPage);
  return path;
};

/** Raw progress fill for a step index — recomputes from the live industry value. */
export const computeVafFlowProgressValue = (self, stepIndex, steps) => {
  const stepComponent = steps[stepIndex]?.component;
  if (!stepComponent || NON_PROGRESS_STEPS.has(stepComponent)) {
    return null;
  }

  const industry = self.props?.company_store?.industry || "";
  const path = buildVafProgressPath(industry);
  const pathIndex = path.indexOf(stepComponent);
  if (pathIndex === -1) {
    return null;
  }

  const totalSteps = path.length;
  return totalSteps <= 1 ? 1 : Math.min(1, Math.max(0, (pathIndex + 1) / totalSteps));
};

/**
 * VafFlow progress fill, mirroring searchFlowVersionB's ASP progress bar.
 * Value is stored on the flow instance and only updated on step navigation —
 * picking an industry with more steps (e.g. one with an activity screen) while
 * still sitting on VafIndustrySelect must not shift the bar under the user.
 */
export const getVafFlowProgress = (self, activeStep, steps) => {
  const stepComponent = steps[activeStep]?.component;
  if (!stepComponent || NON_PROGRESS_STEPS.has(stepComponent)) {
    return null;
  }

  const stored = self.state?.vafProgressValue;
  const storedStep = self.state?.vafProgressStep;
  if (stored != null && storedStep === activeStep) {
    return { value: stored };
  }

  const value = computeVafFlowProgressValue(self, activeStep, steps);
  if (value === null) {
    return null;
  }
  return { value };
};
